import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import ChannelService from '../../services/channel';
import { CustomPageResponse } from '../../models/channels/types';

/**
 * Query key factory for custom page data
 */
export const customPageQueryKey = (topicId: string, customPageId: string) => [
  'custom-page',
  topicId,
  customPageId,
];

/**
 * Fetch custom page content from the API
 *
 * @param topicId - The topic/channel ID
 * @param customPageId - The custom page ID
 * @param options - Optional React Query options
 * @returns Query result with custom page data
 */
export const useCustomPageQuery = (
  topicId: string,
  customPageId: string,
  options?: Omit<
    UseQueryOptions<CustomPageResponse, Error, CustomPageResponse, string[]>,
    'queryKey' | 'queryFn'
  >
) => {
  const query = useQuery<
    CustomPageResponse,
    Error,
    CustomPageResponse,
    string[]
  >({
    queryKey: customPageQueryKey(topicId, customPageId),
    queryFn: async () => {
      const service = new ChannelService(topicId);
      const response = await service.fetchCustomPage(customPageId);
      return response.data;
    },
    enabled: !!topicId && !!customPageId,
    ...options,
  });

  return query;
};
